import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import {Field, reduxForm} from "redux-form";
import MenuItem from "material-ui/MenuItem";
import Button from "react-bootstrap/lib/Button";
import * as actions from "../../../../redux/actions/Attendance/attendanceActions";
import toastr from "toastr";
import {SelectField, TextField} from "redux-form-material-ui";

let name;

class RegularisationTable extends React.Component {

  constructor() {
    super();
    this.state = {processStatus: null};
    this.changeStatus = this.changeStatus.bind(this);
    this.selectField = this.selectField.bind(this);
    this.textField = this.textField.bind(this);
    this.formId = this.formId.bind(this);

  }

  changeStatus(status) {
    this.setState({processStatus: status})
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }

  formId() {
    return this.props.regularization.id;
  }

  selectField(cell, row, formatExtraData, rowIdx) {
    return <Field width={'90%'} style={{marginTop: '20px'}} name={"regularizedReason" + rowIdx} component={SelectField}
                  lable="Regularization Reason">
      <MenuItem value={"Select Reason"} primaryText="Select Reason" disabled={true} selected={true}/>
      <MenuItem value={"out of office duty"} primaryText="Out of office duty"/>
      <MenuItem value={"swipe issue"} primaryText="Swipe Issue"/>
      <MenuItem value={"forgot to carry id card"} primaryText="Forgot to carry Idcard"/>
      <MenuItem value={"man hours not completed"} primaryText="Incomplete Man Hours"/>
      <MenuItem value={"weekly off"} primaryText="Weekly off"/>
    </Field>;
  }

  textField(cell, row, formatExtraData, rowIdx) {
    return <Field name={"remarks" + rowIdx + this.props.regularization.id} component={TextField}
                  style={{width: "100%", marginTop: 0}}
                  hintText="Enter comments if any"
                  multiLine={true}
                  rows={1}
                  rowsMax={4}/>;

  }

  render() {
    let name = this.props.regularization.id;
    const {handleSubmit, pristine, reset, submitting} = this.props;

    return (
      <div>
        <form onSubmit={handleSubmit((data)=> {
          let request = {};

          if (this.state.processStatus == 're-regularize' || this.state.processStatus == 'rejected') {
            if (data["comment" + this.props.regularization.id] == null) {
              toastr.error("Kindly specify a Reason");
              return;
            }

          }
          request.remark = data["comment" + this.props.regularization.id] ? data["comment" + this.props.regularization.id] : "";
          request.id = this.props.regularization.id;
          request.applicantId = this.props.regularization.applicantId;
          request.processStatus = this.state.processStatus;
          request.regularization = new Array();
          this.props.regularization.regularization.map((node, index)=> {
            request.regularization[index] = {};
            request.regularization[index].attendanceDate = node.attendanceDate;
            request.regularization[index].remark = data["remarks" + index + this.props.regularization.id] ? data["remarks" + index + this.props.regularization.id] : "";
          });
          this.props.dispatch(actions.applyTeamRegularisation({data: request}));
        })}
        >


          <img src="/public/images/q_logo.svg" style={{height: '25px'}}/>
          &nbsp; <label style={{
          color: "#428BCA",
          'fontWeight': 'bold',
          'fontSize': '15',
          paddingBottom: '5px',
          paddingLeft: '5px',
          paddingTop: '10px'
        }}
        > {this.props.regularization.applicantId + ' - ' + this.props.regularization.applicantName} </label>
          <BootstrapTable data={[this.props.regularization]}
                          containerStyle={{
                            borderTopStyle: 'solid',
                            borderWidth: '1px',
                            borderColor: '#008bcf',
                          }}>
            <TableHeaderColumn
              className="rowX"
              dataFormat={this.checkNull}
              isKey={true} dataField="startDate" width={"70"}>Start Date</TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.checkNull}
              className="rowX"
              dataField="endDate" width={"70"}>End Date</TableHeaderColumn>
            <TableHeaderColumn
              className="rowX"
              dataFormat={this.checkNull}
              dataField="manHours" width={"100"}>Man Hrs</TableHeaderColumn>
            <TableHeaderColumn
              className="rowX"
              dataFormat={this.checkNull}
              dataField="applicantComment" width={"200"}>
              Applicant Comment </TableHeaderColumn>
            <TableHeaderColumn
              className="rowX"
              columnClassName="rowX" dataField="comment" width={"210"} dataFormat={()=> {
              return <Field name={"comment" + this.props.regularization.id} component={TextField}
                            style={{width: "100%", marginTop: 0}}
                            hintText="Enter comments if any"
                            multiLine={true}
                            rows={1}
                            rowsMax={4}/>;
            }}>Manager's Remarks</TableHeaderColumn>
          </BootstrapTable>

          <BootstrapTable data={this.props.regularization.regularization} striped={false} hover={true} condensed={true}>
            <TableHeaderColumn
              dataFormat={this.checkNull}
              columnClassName="rowX" dataSort={false} isKey={true} width={120} dataField="attendanceDate">Attendance
              <br/> Date</TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.checkNull}
              columnClassName="rowX" dataSort={false} width={100} dataField="systemInTime">System <br/> In
              Time</TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.checkNull}
              columnClassName="rowX" dataSort={false} width={100} dataField="systemOutTime">System <br/>Out
              Time</TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.checkNull}
              columnClassName="rowX" dataField="regularisedReason">Regularized Reason</TableHeaderColumn>
            <TableHeaderColumn
              dataFormat={this.checkNull}
              columnClassName="rowX" dataField="applicantComment">Applicant Comment</TableHeaderColumn>
            <TableHeaderColumn columnClassName="rowX" dataField="remark" dataFormat={this.textField}>Manager
              Remark</TableHeaderColumn>
          </BootstrapTable>
          <div>
            <Button style={{marginRight: '20px'}}
                    onClick={()=> {
                      this.changeStatus('approved')
                    }}
                    type="submit">Approve</Button>
            <Button style={{marginRight: '20px'}}
                    onClick={()=> {
                      this.changeStatus('re-regularize');
                    }}
                    type="submit">Re-Regularize</Button>
            <Button style={{marginRight: '20px'}}
                    onClick={()=> {
                      this.changeStatus('rejected');
                    }}
                    type="submit">Reject</Button>
          </div>
        </form>
      </div>
    );
  }
}

RegularisationTable.propTypes = {};
export default reduxForm({
  form: "team",


})(RegularisationTable)




/** WEBPACK FOOTER **
 ** ./src/feature/attendance/MyAttendance/ReactTable/TeamRegularisationTable.js
 **/